import { all, fork } from 'redux-saga/effects'

import StatisticsSaga from './StatisticsSaga'

export default function* statisticsSagas() {
  yield all([fork(new StatisticsSaga().supervise)])
}
